import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { avoidFavorSetSchema } from '../schemas/avoid-favor-set.schema';

/**
 * Requests the Avoid Favor Sets associated with specific Vehicle Groups
 * @param ids The vehicle group IDs for the vehicle whose Avoid Favor Sets are being requested
 * @returns The Avoid Favor Sets
 */
export function getAvoidFavorSetsVehicleGroups(this: unknown, ids: number[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetEnvironment.resolve(this).avoidFavorSetsVehicleGroupsUrl
        }?vehicleGroupIds=${ids.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(avoidFavorSetSchema.omit({ vehicleGroups: true })),
      })
    )
  );
}
